<template>
    <div class="box">
        <h4 class="mb-3">{{ pointsTitle }} TARGET - {{ target }} WEEKLY {{ pointsTitle }}</h4>
        <div class="bar-chart" :style="'--max-value: ' + target + '; --min-value: 0;'" v-if="workout_data">
            <div class="axis">
                <div v-for="y in calculateTicks(50, target, 10)" :key="y" :data-display-label="y"></div>
            </div>
            <div class="line-target"><div :style="'--target-value: ' + target"></div></div>
            <div v-for="(week, week_index) in workout_data"
                 :key="week_index"
                 class="bar"
                 :style="'--bar-value: ' + (week ? Math.min(week.total, target) : 0) "
                 :data-axis-label="'W ' + (week_index + 1) ">
                <span class="weekly-total" :class="{'under': (week ? week.total : 0) >= 400}" v-if="week_index + 1 <= currentWeek">{{ week ? week.total : 0 }}</span>
                <template v-for="(workout, workout_index) in (week ? week.workouts : [])">
                    <div :key="workout_index" v-if="workout <= target" class="workout" :style="'--workout-value: ' + workout"></div>
                </template>
                <div v-if="parseInt(week_index + 1) === parseInt(currentWeek)" class="target" :style="'--target-value: ' + target"><div class="arrow"></div></div>
            </div>


        </div>
    </div>
</template>

<script>
import {mapGetters, mapState} from "vuex";

export default {
    name: "PointsGraph",
    methods: {
        calculateTicks(min, max, tickCount) {
            var span = max - min,
                step = Math.pow(10, Math.floor(Math.log(span / tickCount) / Math.LN10)),
                err = tickCount / span * step;

            // Filter ticks to get closer to the desired count.
            if (err <= .15) step *= 10;
            else if (err <= .35) step *= 5;
            else if (err <= .75) step *= 2;

            // Round start and stop values to step interval.
            var tstart = Math.ceil(min / step) * step,
                tstop = Math.floor(max / step) * step + step * .5,
                ticks = [];

            // now generate ticks
            for (var i=tstart; i < tstop; i += step) {
                ticks.push(i);
            }
            return ticks.reverse();
        }
    },
    data () {
        return {
            target: 450,
        }
    },
    computed: {
        maxValue () {
            var data = [...this.workout_data]
            var highest = data.sort((a, b) => b.total - a.total)
            var highestTotal = 0
            console.log(highest)
            if(highest.length > 0 && highest[0]) highestTotal = highest[0].total
            else highestTotal = 0
            return Math.max(this.target, highestTotal)
        },
        pointsTitle () {
          if(!this.user) return 'Points'
          return this.user.bft_cubed ? 'PXI' : 'MEPS'
        },
        ...mapGetters({
            currentWeek: 'challenge/currentWeek',
            totalWeeks: 'challenge/weeks',
            user: 'auth/user',
        }),
        ...mapState({
          workout_data: state => state.data.workout_data
        })
    }
}
</script>

<style lang="scss">

    .box {
        width: 100%;
        margin: 0;
        display: inline-block;
        vertical-align: top;
        background-color: #eee;
        border: 1px solid #ddd;
        border-radius: 4px;
        padding: 20px;
        h5 {
            text-transform: uppercase;
        }
        h4 {
            font-size: 15px;
            font-weight: 700;
        }
    }
    :root {
        --max-value: 0;
        --min-value: 0;
        --bar-value: 0;
    }
    .bar-chart {
        width: 100%;
        height: 200px;
        display: flex;
        justify-content: space-around;
        box-sizing: border-box;
        border-bottom: 1px solid #000;
        margin-bottom: 40px;
        padding: 10px 10px 0 10px;
    }
    .axis {
        font-size: 10px;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        position: relative;
        border-right: 1px solid #000;
    }
    .axis > div {
        position:relative;
        top: -12px;
    }
    .axis > div:before {
        margin-right: 5px;
        margin-bottom: 5px;
        content: attr(data-display-label);
        width: calc(100% - 15px);
        text-align: right;
        display: block;
    }

    .bar {
        background: rgba(0, 150, 191, .2);
        position: relative;
        flex: 1;
        margin-right: 10px;
        span.weekly-total {
            bottom: calc(var(--bar-value) / (var(--max-value)) * 100%);
            width: 100%;
            text-align: center;
            position: absolute;
            font-size: 10px;
            font-weight: 600;
            z-index: 998;
            &.under {
                //color: #FFFFFF;
                bottom: calc(var(--bar-value) / (var(--max-value)) * 100% - 20px);
            }
        }
        div.target {
            position: absolute;
            bottom: calc(var(--target-value) / (var(--max-value)) * 100%);
            width: 100%;
            display: flex;
            justify-content: center;
            z-index: 8;
            .line {
                border-top: 1px solid #6EC11D;
                width: 100%;
            }
            .arrow {
                width: 0;
                height: 0;
                border-left: 10px solid transparent;
                border-right: 10px solid transparent;
                border-top: 10px solid #6EC11D;
            }
        }
        div.workout {
            background: #4db6d2;
            height: 2px;
            width: 100%;
            position: absolute;
            bottom: calc(var(--workout-value) / (var(--max-value)) * 100%);
            z-index: 9;
            animation:1s ease 1s normal forwards 1 fadein;
            -webkit-animation:1s ease 1s normal forwards 1 fadein;
            opacity:0
        }
    }

    div.line-target {
        width: 100%;
        position: absolute;
        left: 0;
        padding: 0 20px 0 20px;
        div {
            position: relative;
            bottom: calc(var(--target-value) / (var(--max-value)) * 100%);
            width: 100%;
            z-index: 8;
            border-top: 2px solid #6EC11D;
        }


    }

    .bar:before {
        position: absolute;
        top: calc(100% + 20px);
        width: calc(100% + 10px);
        text-overflow: ellipsis;
        overflow: hidden;
        text-align: center;
        left: -12px;
        content: attr(data-axis-label);
        transform: rotate(-60deg);
        font-size: 10px;
        font-weight: bold;
        white-space: nowrap;
    }

    .bar:after {
        width: 100%;
        position: absolute;
        bottom: 0px;
        left: 0px;
        content: "";
        background: #0096BF;
        z-index: 1;
        height: calc(var(--bar-value) / (var(--max-value)) * 100%);
        animation: height 1s linear;
    }

    @keyframes height {
        0% {
            height: 0px;
        }
    }

    .horizontal {
        flex-direction: column;
        margin-left: 50px;
        justify-content: space-around;
        .bar {
            margin-right: 0;
            margin-bottom: 10px;
            width: 100%;
            height: 65px;
        }

        .axis {
            flex-direction: row;
            width: 100%;
            border-right: 0;
            border-top: 1px solid #000;
            justify-content: space-between;
        }
    }

    @keyframes width {
        0% {
            width: 0px;
        }
    }
    @keyframes fadein{from{opacity:0}
        to{opacity:1}
    }

    @-webkit-keyframes fadein{from{opacity:0}
        to{opacity:1}
    }

    @media only screen
    and (max-device-width: 375px) {
        .box {
            width: 95%;
            margin-left: 10px;
        }
        .bar {
            margin-right: 3px;
        }
    }

</style>
